const getItemsFromSection = section => {
  if (section.items) {
    return section.items.reduce((acc, item) => {
      return [...acc, item, ...getItemsFromSection(item)];
    }, []);
  }
  return [];
};

const flatRoutes = config =>
  config.reduce((acc, section) => {
    return [...acc, ...getItemsFromSection(section)];
  }, []);

export const getRouteConfig = (config, name) =>
  flatRoutes(config).find(
    route =>
      route.link === (Array.isArray(name) ? name.join('/') : name) &&
      route.uuid,
  );

export const getRouteConfigByUuid = (config, uuid) =>
  flatRoutes(config).find(route => route.uuid === uuid);

export const transformEnplusLink = config => {
  const flattenSections = sections => {
    if (!sections) return [];
    return sections.reduce((acc, section) => {
      return [...section, ...acc];
    }, []);
  };
  return config.reduce((acc, section) => {
    return [
      {
        title: section.key,
        items: flattenSections(section.sections),
      },
      ...acc,
    ];
  }, []);
};
